import { render } from "./ProductDescription.vue?vue&type=template&id=2f600632"
import script from "./ProductDescription.vue?vue&type=script&lang=js"
export * from "./ProductDescription.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__